module.exports = __webpack_public_path__ + "img/27_60.0813de23.png";